import React from 'react'
import range from 'lodash/range'

import COLORS from '../styles/colors'

interface Props {
  setValue: (info: string, value: any) => void
  type: string
  selectedValue: number | undefined
  hasDoesntMatter: boolean
  hasPlusSign?: boolean | undefined
  min: number
  max: number
}

const RoundedButtonsRow = (props: Props) => {
  const { min, max } = props
  const array = range(min, max + 1)

  return (
    <div style={styles.container}>
      {props.hasDoesntMatter && (
        <button
          style={{ ...styles.button(props.selectedValue === undefined, false), ...styles.doesntMatterBtn }}
          onClick={() => props.setValue(props.type, undefined)}
        >
          {'Não importa'}
        </button>
      )}
      {array.map((i, index) => {
        const isLast = index === array.length - 1
        return (
          <button
            key={i}
            style={styles.button(props.selectedValue === i, isLast)}
            onClick={() => props.setValue(props.type, i)}
          >
            {isLast && props.hasPlusSign ? `${i}+` : i}
          </button>
        )
      })}
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: 16,
    maxWidth: 324,
  },
  doesntMatterBtn: {
    minWidth: 60,
    height: 'auto',
  },
  button: (selected: boolean, isLast: boolean) => ({
    borderRadius: 37 / 2,
    border: `1px solid ${selected ? COLORS.brand.primaryDark : COLORS.gray}`,
    backgroundColor: selected ? COLORS.brand.primaryDark : 'transparent',
    color: selected ? COLORS.greyscale.white : COLORS.gray,
    fontSize: 12,
    padding: 5,
    minWidth: 37,
    height: 37,
    cursor: 'pointer',
    marginRight: isLast ? 0 : 16,
  }),
}

export default RoundedButtonsRow
